import React, { useMemo } from "react";
import AppDataTable from "../common/AppDataTable";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  DASHBOARD_BODY_CELL_SX,
  DASHBOARD_HEAD_CELL_SX,
  DASHBOARD_PAPER_SX,
  DASHBOARD_TABLE_MAX_HEIGHT,
  DASHBOARD_OVERDUE_TABLE_MIN_HEIGHT,
} from "./dashboardTableStyles";

const DashboardMrtTable = ({
  columns,
  data,
  isLoading = false,
  emptyMessage = "No data available",
  unitName = "people",
  initialSorting = [],
  className = "",
  enableRowVirtualization = false,
  tableContainerFitContent = false,
  tableContainerHeight = DASHBOARD_TABLE_MAX_HEIGHT,
  tableContainerMinHeight = DASHBOARD_OVERDUE_TABLE_MIN_HEIGHT,
  scrollContainer = false,
  enableExpanding = false,
  getSubRows,
  enablePagination = false,
  enableServerSide = false,
  rowCount,
  state = {},
  onPaginationChange,
  onExpandedChange,
  onSortingChange,
}) => (
  <div
    className={`dashboard-mrt-table${scrollContainer ? " dashboard-mrt-table--scroll" : " dashboard-mrt-table--fit"}${className ? ` ${className}` : ""}`}
  >
    <AppDataTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      enableServerSide={enableServerSide}
      enableRowVirtualization={enableRowVirtualization}
      enableGlobalFilter={false}
      enableTopToolbar={false}
      enablePagination={enablePagination}
      enableMultiSorting={false}
      isLoading={isLoading}
      emptyMessage={emptyMessage}
      initialSorting={initialSorting}
      tableContainerHeight={scrollContainer ? undefined : tableContainerHeight}
      tableContainerMinHeight={scrollContainer ? tableContainerMinHeight : undefined}
      tableContainerFitContent={tableContainerFitContent}
      scrollContainer={scrollContainer}
      enableExpanding={enableExpanding}
      getSubRows={getSubRows}
      unitName={unitName}
      rowCount={rowCount}
      state={state}
      onPaginationChange={onPaginationChange}
      onExpandedChange={onExpandedChange}
      onSortingChange={onSortingChange}
      muiTableHeadCellProps={{ sx: DASHBOARD_HEAD_CELL_SX }}
      muiTableBodyCellProps={{ sx: DASHBOARD_BODY_CELL_SX }}
      muiTablePaperProps={{ sx: DASHBOARD_PAPER_SX }}
      icons={{
        ExpandMoreIcon: KeyboardArrowDownIcon,
        ChevronRightIcon: KeyboardArrowRightIcon,
      }}
    />
  </div>
);

export default DashboardMrtTable;

